import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import store from '../../store';
// Material components
import { AppBar, Toolbar, Typography, Hidden, Grid } from '@material-ui/core';
// Custom Components
import SideBar from '../SideBar';
import Login from '../Login';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { flex, fonts } from '../../assets/jss'
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        ...fonts.secondary
    },
    appbarRight: {
        ...flex.flex_row_end
    },
    appbarLeft: {
        ...flex.flex_row_start,
        alignItems: 'center'
    },
    link: {
        textDecoration: 'none',
        color: 'white',
        fontWeight: 600,
        marginLeft: 12
    }
}));

export default function Appbar() {
    const classes = useStyles();
    const { state, profile } = useContext(store);
    const { user } = state;
    const [appBarBackground, setAppBarBackground] = useState('')

    useEffect(() => {
        if (!state.user.isAnonymous) {
            setAppBarBackground(profile.settings.appBarBackground)
        }
        //eslint-disable-next-line
    }, [profile])

    return (
        <div className={classes.root}>
            <AppBar style={{ background: appBarBackground }} position='fixed'>
                <Toolbar>
                    <Grid container alignItems='center'>
                        <Grid item xs={6} sm={4}
                            className={classes.appbarLeft}>
                            {user.uid === undefined ? null : <SideBar />}
                            <Link to='/' className={classes.link}>
                                <Typography variant="h6" className={classes.title}>
                                    5WS
                                </Typography>
                            </Link>
                        </Grid>
                        <Hidden xsDown>
                            <Grid item xs={4}>

                            </Grid>
                        </Hidden>
                        <Grid item xs={6} sm={4}
                            className={classes.appbarRight}>
                            <Login />
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </div>
    );
}